import React from "react";
import { Card, CardBody, Col, Table, Row } from "reactstrap";
import { recentApplicants } from "../../../common/data/dashboardJobs";

const Defaulters = () => {
  return (
    <React.Fragment>
      <Row>
        <Col md={12}>
          <Card className="card-height-100">
            <div className="card-header align-items-center d-flex">
              <div className="card-title mb-0 flex-grow-1 fw-bold">
                Top 6 defaulters
              </div>
            </div>

            <CardBody>
              <div className="table-responsive table-card">
                <Table className="table-border table-centered align-middle table-nowrap mb-0">
                  <thead className="text-muted table-light">
                    <tr>
                      <th scope="col"> Name</th>

                      <th scope="col">Amount</th>
                    </tr>
                  </thead>
                  <tbody>
                    {recentApplicants.map((item, key) => (
                      <tr key={key}>
                        <td>
                          <div className="d-flex align-items-center">
                            <div className="flex-shrink-0 me-2">
                              <img
                                src={item.img}
                                alt=""
                                className="avatar-xs rounded-circle"
                              />
                            </div>
                            <div className="flex-grow-1">
                              {item.name}
                              <div className="text-muted fs-12 ms-1">
                                {item.city}
                              </div>
                            </div>
                          </div>
                        </td>

                        <td>
                          <span
                            style={{ fontSize: "12px" }}
                            className="text-muted"
                          >
                            {item.rate}
                          </span>
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </Table>
              </div>
            </CardBody>
          </Card>
        </Col>
      </Row>
    </React.Fragment>
  );
};

export default Defaulters;
